export default __webpack_public_path__ + "static/stayUpToDate-acc4ec25659fd6a63c93ab6f31fdd028.png";